import _classCallCheck from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/amandayeh/Documents/GitHub/scrollbar-piano/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
import { Solo } from "./Solo";
import { PanVol } from "./PanVol";
import { readOnly } from "../../core/util/Interface";
import { Gain } from "../../core/context/Gain";
/**
 * Channel provides a channel strip interface with volume, pan, solo and mute controls.
 * See [[PanVol]] and [[Solo]]
 * @example
 * // pan the incoming signal left and drop the volume 12db
 * const channel = new Tone.Channel(-0.25, -12);
 * @category Component
 */

export var Channel = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Channel, _ToneAudioNode);

  var _super = _createSuper(Channel);

  function Channel() {
    var _this;

    _classCallCheck(this, Channel);

    _this = _super.call(this, optionsFromArguments(Channel.getDefaults(), arguments, ["volume", "pan"]));
    _this.name = "Channel";
    var options = optionsFromArguments(Channel.getDefaults(), arguments, ["volume", "pan"]);
    _this._solo = _this.input = new Solo({
      solo: options.solo,
      context: _this.context
    });
    _this._panVol = _this.output = new PanVol({
      context: _this.context,
      pan: options.pan,
      volume: options.volume,
      mute: options.mute,
      channelCount: options.channelCount
    });
    _this.pan = _this._panVol.pan;
    _this.volume = _this._panVol.volume;

    _this._solo.connect(_this._panVol);

    readOnly(_assertThisInitialized(_this), ["pan", "volume"]);
    return _this;
  }

  _createClass(Channel, [{
    key: "_getBus",

    /**
     * Get the gain node belonging to the bus name. Create it if
     * it doesn't exist
     * @param name The bus name
     */
    value: function _getBus(name) {
      if (!Channel.buses.has(name)) {
        Channel.buses.set(name, new Gain({
          context: this.context
        }));
      }

      return Channel.buses.get(name);
    }
    /**
     * Send audio to another channel using a string. `send` is a lot like
     * [[connect]], except it uses a string instead of an object. This can
     * be useful in large applications to decouple sections since [[send]]
     * and [[receive]] can be invoked separately in order to connect an object
     * @param name The channel name to send the audio
     * @param volume The amount of the signal to send.
     * 	Defaults to 0db, i.e. send the entire signal
     * @returns Returns the gain node of this connection.
     */

  }, {
    key: "send",
    value: function send(name) {
      var volume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bus = this._getBus(name);

      var sendKnob = new Gain({
        context: this.context,
        units: "decibels",
        gain: volume
      });
      this.connect(sendKnob);
      sendKnob.connect(bus);
      return sendKnob;
    }
    /**
     * Receive audio from a channel which was connected with [[send]].
     * @param name The channel name to receive audio from.
     */

  }, {
    key: "receive",
    value: function receive(name) {
      var bus = this._getBus(name);

      bus.connect(this);
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Channel.prototype), "dispose", this).call(this);

      this._panVol.dispose();

      this.pan.dispose();
      this.volume.dispose();

      this._solo.dispose();

      return this;
    }
  }, {
    key: "solo",

    /**
     * Solo/unsolo the channel. Soloing is only relative to other [[Channels]] and [[Solo]] instances
     */
    get: function get() {
      return this._solo.solo;
    },
    set: function set(solo) {
      this._solo.solo = solo;
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed,
     * or the channel is muted
     */

  }, {
    key: "muted",
    get: function get() {
      return this._solo.muted || this.mute;
    }
    /**
     * Mute/unmute the volume
     */

  }, {
    key: "mute",
    get: function get() {
      return this._panVol.mute;
    },
    set: function set(mute) {
      this._panVol.mute = mute;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        pan: 0,
        volume: 0,
        mute: false,
        solo: false,
        channelCount: 1
      });
    }
  }]);

  return Channel;
}(ToneAudioNode);
/**
 * Store the send/receive channels by name.
 */

Channel.buses = new Map();